import App from "./App.svelte";

// adapted from https://github.com/thismatters/django-svelte-template/blob/master/src/main-app.js
const app = new App({
  target: document.getElementById("elex-timeline"),
  props: JSON.parse(document.getElementById("timeline-props").textContent),
});

export default app;
